import * as React from 'react';
import { useState, useEffect, useRef, useContext } from 'react';

import { isEmpty, pdfData } from '../../utils/common';

import { CSVLink } from 'react-csv';
import Bbpslogo from '../../assets/images/BbpsLogo.png';
import bbpsLogo2 from '../../assets/images/BBPS3.svg';
import { useNavigate } from 'react-router-dom';
import { bbpsCheckComplainStatus, bbpsComplainList } from '../../utils/api';
import BbpsReceipt from '../../Pages/BBPSComplaint/BbpsReceipt';
import { GlobleContaxt } from '../../Context/GlobleContaxt';

import BbpsComplaintReceipt from './BbpsComplaintReceipt';
import Pagination from '../../Components/Pagination/Pagination';
import Loader from '../../Components/UI/Loader/Loader';
import { FilterWrapper, TableWrapper } from '../../Components/UI/styledConstants';
import { ServiceBoxWrapper } from '../../Components/ServicesBox/style';
import LocalLoader from '../../Components/UI/Loader/LocalLoader';
import Back from '../../Components/UIbox/Back';

const ComplaintHistory = () => {
	const [downloadLoader, setDownloadLoader] = useState('');
	const [filter, setFilter] = useState({
		fromDate: '',
		toDate: '',
		txnId: '',
		txnRefId: '',
		refId: '',
		status: '',
		pageNo: 0,
		pageSize: 10,
	});

	const [loading, setLoading] = useState(null);

	const [complaintHistory, setComplaintHistory] = useState([]);
	const [paging_data, setPagingData] = useState(null);
	const [totalElement, setTotalElement] = useState('');
	const [csvData, setCsvData] = useState([]);
	const [complainDaitals, setComplainDaitals] = useState({});
	const [statusData, setStatusData] = useState({});

	const link = useRef(null);
	const navigate = useNavigate();
	const { setAlert,userDetails } = useContext(GlobleContaxt);

	const getComplaintHistory = async (key = '', page = 0) => {
		let fromDate = '';
		let toDate = '';

		if (!isEmpty(filter.fromDate)) {
			const parts = filter.fromDate.split('-');
			const formattedDate = parts[0] + '-' + parts[1] + '-' + parts[2];
			fromDate = formattedDate;
		}
		if (!isEmpty(filter.toDate)) {
			const parts = filter.toDate.split('-');
			const formattedDate = parts[0] + '-' + parts[1] + '-' + parts[2];
			toDate = formattedDate;
		}

		const payload = {
			toDate: toDate,
			fromDate: fromDate,
			txnId: filter.txnId,
			refId: filter.refId,
			refTxnId: filter.txnRefId,
			status: '',
			complaintStatus: filter.status,
			userUuid: userDetails?.uuid,
			pagination: {
				pageNo: filter.pageNo,
				pageSize: filter.pageSize,
			},
		};

		if (key === 'csv' || key === 'pdf') {
			if (key === 'csv') {
				setDownloadLoader('csv');
			} else {
				setDownloadLoader('pdf');
			}
			payload.pagination.pageSize = totalElement;
		} else if (key !== '') {
			payload.pagination.pageNo = 0;
			setLoading(true);
		} else {
			setLoading(true);
		}
		if (key === 'pagination') {
			payload.pagination.pageNo = page;
		}

		if (key === 'refresh') {
			payload.toDate = '';
			payload.fromDate = '';
			payload.txnId = '';
			payload.refTxnId = '';
			payload.complaintStatus = '';
			payload.refId = '';

			setFilter({ fromDate: '', toDate: '', txnId: '', refId: '', status: '', pageNo: 0, pageSize: 10 });
		}

		bbpsComplainList(payload).then((resp) => {
			setLoading(false);
			setDownloadLoader('');
			if (resp?.success) {
				if (key !== 'csv' && key !== 'pdf') {
					setComplaintHistory(resp?.data?.content);
					setTotalElement(resp?.data?.totalElements);
					setPagingData({
						number: resp?.data?.number,
						totalPages: resp?.data?.totalPages,
					});
				} else if (key === 'csv') {
					setCsvData(resp?.data?.content);

					const csvlink = link.current;
					csvlink.link.click();
				} else if (key === 'pdf') {
					setCsvData(resp?.data?.content);
					pdfDownload(resp?.data?.content);
				}
			} else {
				if (resp?.errorCodeList.length > 0 && !isEmpty(resp?.errorCodeList[0])) {
					setAlert({ type: 'error', msg: resp?.errorCodeList[0] });
				} else {
					setAlert({ type: 'error', msg: resp?.msg });
				}
				setComplaintHistory([]);
			}
		});
	};

	const filterChangeHandler = (e) => {
		const { name, value } = e.target;
		if (name === 'toDate') {
			if (isEmpty(filter.fromDate)) {
				return false;
			}
		}
		setFilter({ ...filter, pageNo: 0, [name]: value.trim() });
	};

	useEffect(() => {
		getComplaintHistory('');
	}, []);
	const headers = [
		{ label: 'Mobile No.', key: 'mobile' },
		{ label: 'B-Connect Txn ID', key: 'refTransactionId' },
		{ label: 'Complaint Id', key: 'complaintId' },
		{ label: 'Complaint Date', key: 'createdDate' },
		{ label: 'Complaint Status', key: 'complaintStatus' },
	];

	const pdfDownload = (data) => {
		const tableHeader = [
			{
				mobile: 'Mobile No.',
				refTransactionId: 'Reference Transaction Id',
				complaintId: 'Complaint Id',
				createdDate: 'Complaint Date',
				complaintStatus: 'Complaint Status',
			},
		];

		pdfData(data, tableHeader, 'History', 400);
	};

	const ckeckStatus = (complaintId) => {
		setLoading(true);
		bbpsCheckComplainStatus(complaintId).then((resp) => {
			setLoading(false);
			if (resp?.success) {
				if (resp?.data?.status?.toUpperCase() === 'SUCCESS') {
					const msg = 'Your complaint ' + resp?.data?.response?.txnStatusComplainResp?.complaintStatus;

					setStatusData(resp?.data?.response);
				} else {
					setAlert({ type: 'error', msg: resp?.data.response.responseReason });
				}
			} else {
				if (resp?.errorCodeList.length > 0 && !isEmpty(resp?.errorCodeList[0])) {
					setAlert({ type: 'error', msg: resp?.errorCodeList[0] });
				} else {
					setAlert({ type: 'error', msg: resp?.msg });
				}
			}
		});
	};

	const onCloseModal = () => {
		setComplainDaitals({});
	};
	const onCloseModalStatus = () => {
		setStatusData({});
		getComplaintHistory('');
	};

	const changePage = (page) => {
		setFilter({ ...filter, pageNo: page });
		getComplaintHistory('pagination', page);
	};

	return (
		<>
			<div className='container'>
				
				<ServiceBoxWrapper className='bbps'>
							<div className="header flex justify-between items-center">
							<Back url="/" />
								<h2 className="m0">Complaint History</h2>
								<div className="logo">
									<img src={bbpsLogo2} alt="bbps logo" />
								</div>
							</div>
							<div className="service-box-body">
							<div className="flex">
					<div className="personal-information transaction">
					<FilterWrapper className="flex items-center justify-between">
							<div className="filterBox">
								<div className="filter-text">Filter By</div>

								<div className="input-field">
									<input type="text" name="txnRefId" placeholder="B-Connect Txn ID" value={filter.txnRefId} onChange={filterChangeHandler} />
								</div>
								<div className="input-field">
									<input type="text" name="txnId" placeholder="Complaint Id" value={filter.txnId} onChange={filterChangeHandler} />
								</div>
								<div className="input-field">
									<select value={filter?.status} name="status" onChange={filterChangeHandler}>
										<option selected value={''}>
											Complaint status
										</option>
										<option value={'ASSIGNED'}>Assigned</option>
										<option value={'RESOLVED'}>Resolved</option>
										<option value={'FAIL'}>Fail</option>
									</select>
								</div>

								<div className="input-field date-filter">
									<span style={{ fontWeight: '600', marginLeft: '8px' }}>From</span>
									<input type="date" placeholder="DD-MM-YYYY" name="fromDate" value={filter.fromDate} onChange={filterChangeHandler} />
									<span style={{ fontWeight: '600' }}>To</span>
									<input
										type="date"
										placeholder="DD-MM-YYYY"
										name="toDate"
										value={filter.toDate}
										min={filter.fromDate}
										onChange={filterChangeHandler}
										disabled={isEmpty(filter.fromDate)}
									/>
								</div>
								<div className="input-field filter-Button flex gap-10">
									<button className="filterButton" onClick={() => getComplaintHistory('filter')}>
										GO
									</button>
									<button className="filterButton" onClick={() => getComplaintHistory('refresh')}>
										<i class="fa-solid fa-arrows-rotate"></i>
									</button>
									{downloadLoader !== 'csv' ? (
										<button className="filterButton" onClick={() => getComplaintHistory('csv')}>
											CSV
										</button>
									) : (
										<button className="filterButton btn-loader">
											<div className="btn-loader">
												<i className="fa-solid fa-spinner"></i>
											</div>
										</button>
									)}
									{downloadLoader !== 'pdf' ? (
										<button className="filterButton" onClick={() => getComplaintHistory('pdf')}>
											PDF
										</button>
									) : (
										<button className="filterButton btn-loader">
											<div className="btn-loader">
												<i className="fa-solid fa-spinner"></i>
											</div>
										</button>
									)}

									<CSVLink ref={link} data={csvData} filename={'Complaint-History.csv'} headers={headers}></CSVLink>
								</div>
							</div>
						</FilterWrapper>

						<TableWrapper className="mt20 table-card-wrapper">
							{loading && <LocalLoader className="tableLoader" />}
							<table className="table">
								<thead className="table-head">
									<tr>
										<th>Sr. No</th>
										<th>Mobile No.</th>
										<th>B-Connect Txn ID</th>
										<th>Complaint Id</th>
										<th>Complaint Date</th>
										<th>Complaint Status</th>
										<th>Raise complaint</th>
										<th>Check Status</th>
										<th>View</th>
									</tr>
								</thead>
								<tbody className="table-body">
									{complaintHistory &&
										complaintHistory.map((data, i) => {
											const update = new Date(data.createdDate).toLocaleDateString('en-us', {
												day: 'numeric',
												month: 'short',
												year: 'numeric',
												hour: 'numeric',
												minute: 'numeric',
												second: 'numeric',
												hour12: true,
											});

											let status = '';

											if (data?.complaintStatus.toUpperCase() === 'FAIL') {
												status = 'red';
											} else if (data?.complaintStatus.toUpperCase() === 'RESOLVED') {
												status = 'green';
											} else {
												status = '#adad08';
											}
											return (
												<tr key={i}>
													<td>
														<span className="card-th">Sr. No</span>
														<span>{filter.pageSize * filter.pageNo + (i + 1)}</span>
													</td>
													<td>
														<span className="card-th">Mobile No.</span>
														<span>{data?.mobile || '-'}</span>
													</td>
													<td>
														<span className="card-th">Reference Transaction Id</span>
														<span>{data?.refTransactionId || '-'}</span>
													</td>
													<td>
														<span className="card-th">Complaint Id</span>
														<span>{data?.complaintId || '-'}</span>
													</td>
													<td>
														<span className="card-th">Complaint Date</span>
														<span>{update || '-'}</span>
													</td>
													<td>
														<span className="card-th">Complaint Status</span>
														<span style={{ color: status, fontWeight: '700' }}>{data?.complaintStatus || '-'}</span>
													</td>
													<td>
														<span className="card-th">Raise complaint</span>
														{data?.complaintFlag.toUpperCase() !== 'OPEN'?<button className="viewButton" onClick={() => navigate('/raise-complaint', { state: { state: data } })}>
														<i class="fa-solid fa-file-circle-exclamation"></i><span>Complaint</span>
														</button>:"-"}
													</td>
													<td>
														<span className="card-th">Check Status</span>
														{data?.complaintStatus.toUpperCase() !== 'RESOLVED' && data?.complaintStatus.toUpperCase() !== 'FAIL' ? (
															<button className="viewButton" onClick={() => ckeckStatus(data?.complaintId)}>
																<i class="fa-solid fa-list-check"></i><span>Status</span>
															</button>
														) : (
															<span>-</span>
														)}
													</td>
													<td>
														<span className="card-th">View</span>
														<button className="viewButton" onClick={() => setComplainDaitals(data)}>
															<i class="fa-solid fa-eye"></i><span>View</span>
														</button>
													</td>
												</tr>
											);
										})}

									{isEmpty(complaintHistory) && !loading && (
										<tr>
											<td colSpan={'100%'} className="text-center">
												NO record found
											</td>
										</tr>
									)}
								</tbody>
							</table>
						</TableWrapper>
						{paging_data && paging_data?.totalPages > 1 && (
							<Pagination currentPage={paging_data?.number} totalPages={paging_data?.totalPages} getCurrentPageData={(page) => changePage(page)} />
						)}
						{!isEmpty(complainDaitals) && <BbpsComplaintReceipt payDaital={complainDaitals} onCloseModal={onCloseModal} />}
						{!isEmpty(statusData) && <BbpsReceipt payDaital={statusData} onCloseModal={onCloseModalStatus} type="status" />}
					</div>
				</div>
							</div>
				
			</ServiceBoxWrapper>
			</div>
		</>
	);
};
export default ComplaintHistory;